var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #80d4d4;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #00a9a9;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 30px;\n      }\n\n      .cls-5, .cls-4 {\n        fill: #bfeaea;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 600,
    cy: 600.18,
    r: 557.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M330.3,318.22h539.4c31.15,0,56.44,25.29,56.44,56.44v423.75H273.86v-423.75c0-31.15,25.29-56.44,56.44-56.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.62,795.9h694.77c31.15,0,56.44,25.29,56.44,56.44v29.44H196.17v-29.44c0-31.15,25.29-56.44,56.44-56.44Z",
    transform: "translate(1200 1677.68) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 544.9,
    y1: 486.34,
    x2: 801.37,
    y2: 486.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 544.9,
    y1: 560.63,
    x2: 801.37,
    y2: 560.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 544.9,
    y1: 702.17,
    x2: 801.37,
    y2: 702.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 544.9,
    y1: 631.07,
    x2: 801.37,
    y2: 631.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 434.73,
    cy: 664.7,
    r: 38.35
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 479.31,
    y1: 379.23,
    x2: 653.27,
    y2: 379.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 720.69,
    y1: 379.23,
    x2: 720.69,
    y2: 379.23
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 519.21,
    y1: 813.28,
    x2: 693.16,
    y2: 813.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "400.06 509 424.57 533.5 465.34 492.73"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.545bdc9149e182eb965ebb73a4bcde38.svg";
export { ForwardRef as ReactComponent };